<form [formGroup]="criteriaSourceSettingsForm" (ngSubmit)="onSave()">
    <r1-compass-lib-instructions-with-fields-container>
        <r1-compass-lib-instructions headerText="Criteria Source Settings" instructions>
            Enter the table names and columns to define the available options when configuring Sales History and Web
            Activity criteria. If left blank, default values will be applied.
        </r1-compass-lib-instructions>
        <div formArea>
            <r1-compass-lib-form-row name="Sales History Table">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistoryTable }}</mat-label>
                    <input matInput formControlName="salesHistoryTable" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Sales History Cmt Column">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistoryCmtColumn }}</mat-label>
                    <input matInput formControlName="salesHistoryCmtColumn" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Sales History Self Mfg Column">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistorySelfMfgColumn }}</mat-label>
                    <input matInput formControlName="salesHistorySelfMfgColumn" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Sales History Ssp Column">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistorySspColumn }}</mat-label>
                    <input matInput formControlName="salesHistorySspColumn" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Sales History Channels Column">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistoryChannelsColumn }}</mat-label>
                    <input matInput formControlName="salesHistoryChannelsColumn" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Sales History Metrics Column">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistoryMetricsColumn }}</mat-label>
                    <input matInput formControlName="salesHistoryMetricsColumn" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Sales History Product Label Column">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistoryProductLabelColumn }}</mat-label>
                    <input matInput formControlName="salesHistoryProductLabelColumn" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Sales History Vendors Table">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistoryVendorsTable }}</mat-label>
                    <input matInput formControlName="salesHistoryVendorsTable" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Sales History Vendors Column">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultSalesHistoryVendorsColumn }}</mat-label>
                    <input matInput formControlName="salesHistoryVendorsColumn" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Web Activity Table">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultWebActivityTable }}</mat-label>
                    <input matInput formControlName="webActivityTable" />
                </mat-form-field>
            </r1-compass-lib-form-row>
            <r1-compass-lib-form-row name="Web Activity Cmt Column">
                <mat-form-field>
                    <mat-label>Default: {{ DataMartConstants.DefaultWebActivityCmtColumn }}</mat-label>
                    <input matInput formControlName="webActivityCmtColumn" />
                </mat-form-field>
            </r1-compass-lib-form-row>
        </div>
    </r1-compass-lib-instructions-with-fields-container>
    <r1-compass-app-save-division-settings-footer [disabled]="!criteriaSourceSettingsForm.valid" />
</form>
